// DELETE MOVIE
export const deleteMovieRequest = "DELETE_MOVIVE_REQUEST";
export const deleteMovieSuccess = "DELETE_MOVIVE_SUCCESS";
export const deleteMovieFail = "DELETE_MOVIVE_FAIL";
// CHANGE INFO MOVIE
export const changeInfoMovieRequest = "CHANGE_MOVIE_REQUEST";
export const changeInfoMovieSuccess = "CHANGE_MOVIE_SUCCESS";
export const changeInfoMovieFail = "CHANGE_MOVIE_FAIL";
